// Mixin globale: espone this.exportAsync(type, format, filters) in ogni componente.
// Richiede al backend un export asincrono e mostra subito uno snackbar informativo.
export default {
	methods: {
		async exportAsync(type, format, filters = {}) {
			const res = await this.$store.dispatch('downloads/request', { type, format, filters });
			const ok = !(res && res.error);
			this.$store.dispatch('settings/updateSnackbar', {
				color: ok ? 'info' : 'error',
				text: ok ? 'Download in lavorazione: riceverai una mail e una notifica quando sarà pronto.' : 'Errore durante la richiesta di export. Riprova.',
				snackbar: true,
				mode: 'multi-line',
				timeout: 6000,
			});
			return res;
		},
	},
};
